<template>
  <div class="row">
    <div class="col-md-8">
      <b-form-group
        :input-cols="7"
        :label="$t('message.lblSposobUct')">
        <b-form-radio-group
          v-model="$v.items.r10_sposob_uctovania.$model"
          stacked
          plain>
          <b-form-radio value="ev">{{ $t('message.lblDanEvid') }}</b-form-radio>
          <b-form-radio value="ju">{{ $t('message.lblJeUc') }}</b-form-radio>
        </b-form-radio-group>
      </b-form-group>
    </div>
    <div class="col-md-4"/>
    <b-button
      class="btn-primary"
      @click="save">
      {{ $t('message.lblSave') }}
    </b-button>
  </div>
</template>

<script>
import bFormGroup from '@/components/form-group-col4';
import restEditor from '@/mixins/restEditor';

export default {

  components: {
    bFormGroup,
  },

  mixins: [restEditor],
  data() {
    const id = null;
    const parent = this.$route.params.userId;
    return {
      id,
      parent,
      items: {
        id: null,
        parent: null,
        r10_sposob_uctovania: null,
      },
    };
  },

  validations: {
    items: {
      r10_sposob_uctovania: {},
    },
  },

  methods: {
    async processGet() {
      this.id = await this.restDataSource.getSposobId(this.parent, 6);
      if (this.id !== null) {
        this.items = await this.restDataSource.getDataSilent(this.id, 'par6sposob3');
      }
    },

    async processSave() {
      if (this.id === null) {
        this.items.parent = this.parent;
        await this.restDataSource.createData(this.items, 'par6sposob3');
      } else {
        await this.restDataSource.updateItem(this.items, `par6sposob3/${this.id}`);
      }
    },
  },

};
</script>

<style>
.form-row > .col, .form-row > [class*="col-"] {
    padding-right: 30px;
    padding-left: 0px;
}
.form-check-label {
    margin-bottom: 12px;
}
.form-check-inline .form-check-input {
    margin-top: -12px;
}
</style>
